import {useEffect, useState} from 'react';
import {
  useGetQuestions,
  useGetThemes,
} from '../../../core/repositories/entrySheetBuilderRepository';

type QuestionAnswerType = {
  id: number;
  question: string;
  inputType: 'choice' | 'free' | 'hashtag';
  options?: Array<{id: number; choice: string}>;
};

export const useHandleQueryAnswers = () => {
  const [questionAnswers, setQuestionAnswers] = useState<QuestionAnswerType[]>(
    [],
  );
  const [themeId, setThemeId] = useState<number>(0);

  const {data: themes} = useGetThemes({});
  const {data: questions} = useGetQuestions({
    themeId,
    config: {
      enabled: themeId !== 0,
    },
  });

  useEffect(() => {
    if (themes?.ok) {
      const newQuestionAnswers = {
        id: 0,
        question: '何について書きますか？',
        inputType: 'choice' as const,
        options: themes.value.themes.map((theme) => ({
          id: theme.id,
          choice: theme.name,
        })),
      };
      setQuestionAnswers([newQuestionAnswers]);
    }
  }, [themes]);

  useEffect(() => {
    if (questions?.ok) {
      const newQuestionAnswers = questions.value.questions.map((question) => ({
        id: question.id,
        question: question.question,
        inputType: question.questionType as 'choice' | 'free' | 'hashtag',
        options: question.options,
      }));
      setQuestionAnswers((prev) => [...prev, ...newQuestionAnswers]);
    }
  }, [questions]);

  const handleResetQuestionAnswers = () => {
    const newQuestionAnswers = questionAnswers.slice(0, 1);
    setQuestionAnswers(newQuestionAnswers);
  };

  return {
    questionAnswers,
    themeId,
    setThemeId,
    handleResetQuestionAnswers,
  };
};
